import { constantsData, fileData } from "@/data";

export const uploadVideoFileHandler = async (importerData) => {
    const { formMethods, uploadFile, video } = importerData;

    await uploadFile(video?.file, formMethods, fileData.names.video, null, {
        importerData: {
            ...importerData,
            uploadingVideoFile: true,
        },
        videoType: video?.type?.value,
    });
};

export const getVideoTypeHandler = (videoType) => {
    const {
        videoClip: videoClipConstant,
        videoWithoutLogo: videoWithoutLogoConstant,
        withLogo: withLogoConstant,
        withoutLogo: withoutLogoConstant,
    } = constantsData;

    switch (videoType) {
        case withoutLogoConstant:
            return videoWithoutLogoConstant;
        case withLogoConstant:
            return videoClipConstant;
        default:
            return videoType;
    }
};

export const getVideosHandler = (isrc, files) => {
    const videos = [];

    if (isrc) {
        // Video file name convention: "trackIsrc_videoIsrc_videoType"
        const videosObjs = files?.filter(
            (file) =>
                file?.name?.split("_")[0] === isrc &&
                fileData.extensions.video.some((item) => file.name.toLowerCase().includes(item)),
        );

        videosObjs.forEach((video) => {
            const [, ...nameSegments] = video?.name?.split(".")?.[0]?.split("_") || [];

            // Old convention "trackIsrc_videoType" has no video ISRC, so it's left undefined to fail validation
            const [videoIsrc, ...videoTypeSegments] =
                nameSegments.length > 1 ? nameSegments : [undefined, ...nameSegments];

            const videoType = videoTypeSegments.join("_").toUpperCase();

            videos.push({
                file: video,
                isrc: videoIsrc,
                trackIsrc: isrc,
                type: getVideoTypeHandler(videoType),
            });
        });
    }

    return videos;
};
